import { useMutation, useQueryClient } from '@tanstack/react-query';
import { updateRolePermissions } from '../api/ROLES/roles';
import { toast } from 'react-toastify';

export const useUpdateRolePermissions = () => {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: ({ roleId, permissionIds }) => updateRolePermissions(roleId, permissionIds),
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ['roles'] });
            toast.success('Permissions mises à jour avec succès');
        },
        onError: (error) => {
            toast.error(error.response?.data?.message || 'Erreur lors de la mise à jour des permissions');
        },
    });
};
